/* eslint-disable @nx/enforce-module-boundaries */
import { registerLocaleData } from '@angular/common';
import localeEsAR from '@angular/common/locales/es-AR';
import { ApplicationConfig } from '@angular/core';
import { config } from 'rxjs';
import { AppProviders } from './app.providers';

// TODO: sacar
// eslint-disable-next-line @typescript-eslint/ban-types
const existingHandler = config.onUnhandledError;
config.onUnhandledError = function (error: unknown) {
  console.error('rxjs', 'onUnhandledError', 'error', error);
  if (existingHandler) {
    existingHandler.call(this, error);
  }
};

// Fechas y formatos
registerLocaleData(localeEsAR, 'es-AR');

export const AppConfig: ApplicationConfig = {
  providers: AppProviders,
};
